import type { TaskHistoryScope } from '../types/taskHistory';

export function formatTaskHistoryScopeLabel(item: {
  scope: TaskHistoryScope;
  groupLabel?: string | null;
  stopLabel?: string | null;
}): string {
  if (item.scope === 'STOP') {
    return item.stopLabel?.trim() || 'Остановка';
  }
  if (item.scope === 'GROUP') {
    return item.groupLabel?.trim() || 'Группа';
  }
  return 'Маршрут';
}

export function formatTaskHistoryDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatTaskHistoryExecutor(
  completedByUserName: string | null | undefined
): string {
  const name = completedByUserName?.trim();
  return name || '—';
}
